import { useQuery } from '@tanstack/react-query'
import { useBusinessContext } from '@root/context/BusinessContext'
import { useDebouncedValue } from '@root/hooks'
import { useEffect } from 'react'
import { fetchContacts } from '../contacts'

export const useDuplicateContactCount = (
  name: string,
  excludedContactId?: number,
  enabled = true
): number | undefined => {
  const { slug } = useBusinessContext()
  const { debouncedValue: debouncedName, setValue: setDebouncedName } = useDebouncedValue({
    initialValue: name,
    delay: 300
  })
  const trimmedName = debouncedName?.trim() ?? ''
  const isEnabled = enabled && Boolean(trimmedName)

  useEffect(() => {
    setDebouncedName(name)
  }, [name, setDebouncedName])

  const params = {
    name_iexact: trimmedName,
    exclude_id: excludedContactId,
    page: 1,
    page_size: 1 // We are not interested in the actual data, just the count so limit to 1
  }

  const { isSuccess, data } = useQuery({
    queryKey: [slug, 'contacts', params],
    queryFn: () => fetchContacts({ slug }, params),
    staleTime: 60 * 1000, // Stale time of 1 min in ms
    enabled: isEnabled
  })

  return isSuccess ? data?.count : undefined
}
